@if (!filtrando()) {
  <div class="py-2 px-4 flex items-center gap-2 bg-slate-100">
    <span class="subheading-1 flex-none">
      @if (filtros().hasValor) {
        Filtrado por:
      } @else {
        Nenhum filtro aplicado
      }
    </span>
    <div class="flex flex-row gap-2 flex-nowrap flex-1">
      <!-- Aqui vai a listagem dos filtros-->
      @for (filtro of filtros(); track $index) {
        @if (filtro.hasValor) {
          <div
            class="flex flex-row items-center bg-primary-200 rounded-xl text-primary-800 h-7 px-4 gap-4"
            [slcPopover]="listaValoresPopover"
            [slcPopoverContext]="{ filtro }"
          >
            <span class="max-w-60 text-nowrap text-ellipsis overflow-hidden">
              {{ filtro.label }}:
              <!-- -->
              @if (filtro.listaValores.min || filtro.listaValores.max) {
                <!-- -->
                @if (filtro.listaValores.min) {
                  &#8805;
                  <!---->
                  @if (filtro.componente === 'dateRange') {
                    {{ filtro.listaValores.min | date }}
                  } @else {
                    {{ filtro.listaValores.min | number: '0.2-2' }}
                  }
                }
                <!-- -->
                @if (filtro.listaValores.max) {
                  &#8804;
                  <!---->
                  @if (filtro.componente === 'dateRange') {
                    {{ filtro.listaValores.max | date }}
                  }
                } @else {
                  <!-- -->
                  {{ filtro.listaValores.max | number: '0.2-2' }}
                }
              } @else if (filtro.componente === 'date') {
                {{ filtro.listaValores | date }}
              } @else {
                {{ filtro.listaValores }}
              }
            </span>
          </div>
        }
      }
    </div>
    @if (totalLinhas() >= filtros().limiteLinhas) {
      <div class="flex items-center flex-none gap-2">
        <mat-icon svgIcon="mat:info" class="icon-sm slc-color-danger" [slcPopover]="limitePopover"></mat-icon>
        <span class="text-red-500 mt-px">Total de linhas: {{ totalLinhas() }}</span>
      </div>
    } @else {
      <div class="text-gray-500 flex-none">Total de linhas: {{ totalLinhas() }}</div>
    }
  </div>
} @else {
  <div class="bg-app-bar px-6 h-16 border-b left-0 flex items-center rounded-t-md">
    <h2 class="title my-0 pr-4 hidden sm:block flex-none">
      <span>Filtro</span>
    </h2>

    <div class="flex-1"></div>

    <a
      class="text-primary-600 cursor-pointer ml-8"
      (click)="onLimparTodosFiltros()"
      [class.invisible]="!filtros().hasValor"
      >Limpar Todos</a
    >
  </div>

  <form (submit)="onAplicar($event)" class="bg-foreground flex flex-col p-4" [formGroup]="form">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 my-2">
      @for (filtro of filtros(); track $index) {
        <div class="flex flex-col">
          <div class="flex flex-row justify-between items-center px-2">
            <div class="inline-flex">
              <mat-label>{{ filtro.label }}</mat-label>
              <mat-icon
                svgIcon="mat:info"
                class="icon-xs ml-1 slc-color-brand"
                [slcPopover]="infoPopover"
                [slcPopoverContext]="{ info: info()?.[filtro.idFiltro] }"
                [class.hidden]="!info()?.[filtro.idFiltro]"
              ></mat-icon>
              <mat-icon
                svgIcon="mat:info"
                class="icon-xs ml-1 slc-color-danger"
                [slcPopover]="errorMessagePopover"
                [slcPopoverContext]="{ $implicit: filtro.valorAsControl }"
                [class.invisible]="!filtro.hasErrors"
              ></mat-icon>
            </div>

            <a
              class="text-primary-600 cursor-pointer ml-8"
              (click)="onLimparFiltro(filtro)"
              [class.invisible]="!filtro.hasValor"
              >Limpar</a
            >
          </div>
          @switch (filtro.componente) {
            @case ('select') {
              <mat-form-field subscriptSizing="dynamic" class="vex-mat-dense-xxs">
                <mat-select
                  name="item"
                  multiple
                  [formControl]="filtro.valorAsControl"
                  slc-select
                  (selectionChange)="onMarcarTodos($event)"
                >
                  @if (!filtro.semEntradaManual) {
                    <mat-select-trigger>
                      <input
                        matInput
                        [value]="filtro.valorAsControl.value"
                        (change)="onSelectTriggerInputChange($event, filtro)"
                        (click)="$event.stopPropagation()"
                      />
                    </mat-select-trigger>
                  }
                  <mat-option slcSelectAll>(Marcar todos)</mat-option>
                  @for (option of filtro.options(); track $index) {
                    <mat-option class="slc-option" [value]="option.valor">{{ option.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @case ('selectUnique') {
              <mat-form-field subscriptSizing="dynamic" class="vex-mat-dense-xxs">
                <mat-select name="item" [formControl]="filtro.valorAsControl">
                  @if (!filtro.semEntradaManual) {
                    <mat-select-trigger>
                      <input
                        matInput
                        [value]="filtro.valorAsControl.value"
                        (change)="onSelectTriggerInputChange($event, filtro)"
                        (click)="$event.stopPropagation()"
                      />
                    </mat-select-trigger>
                  }
                  @for (option of filtro.options(); track $index) {
                    <mat-option class="slc-option" [value]="option.valor">{{ option.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @case ('input') {
              <mat-form-field subscriptSizing="dynamic" class="vex-mat-dense-xxs">
                <input matInput slcInputPasteToStringList [formControl]="filtro.valorAsControl" />
              </mat-form-field>
            }
            @case ('range') {
              <div
                class="flex flex-row justify-between items-center gap-2 vex-mat-dense-xxs"
                [formGroup]="filtro.valorAsGroup"
              >
                <mat-form-field subscriptSizing="dynamic">
                  <input
                    matInput
                    formControlName="min"
                    [slcCurrency]="{
                      allowNegative: false,
                      max: 999999999.99,
                      nullable: true,
                    }"
                    slcSelectAllOnTouch
                  />
                </mat-form-field>
                até
                <mat-form-field subscriptSizing="dynamic">
                  <input
                    matInput
                    formControlName="max"
                    [slcCurrency]="{
                      allowNegative: false,
                      max: 999999999.99,
                      nullable: true,
                    }"
                    slcSelectAllOnTouch
                  />
                </mat-form-field>
              </div>
            }
            @case ('dateRange') {
              <mat-form-field subscriptSizing="dynamic" class="vex-mat-dense-xxs">
                <mat-date-range-input [rangePicker]="datePicker" [formGroup]="filtro.valorAsGroup">
                  <input matStartDate formControlName="min" maxlength="10" slcDatepickerDateString />
                  <input matEndDate formControlName="max" maxlength="10" slcDatepickerDateString />
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
              </mat-form-field>
              <mat-date-range-picker #datePicker></mat-date-range-picker>
            }
            @case ('date') {
              <mat-form-field subscriptSizing="dynamic" class="vex-mat-dense-xxs">
                <input
                  matInput
                  [formControl]="filtro.valorAsControl"
                  [matDatepicker]="datePicker"
                  slcDatepickerDateString
                />
                <mat-datepicker-toggle [for]="datePicker" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>
            }
          }
        </div>
      }
      <div class="flex justify-end items-end gap-2 md:col-start-2 xl:col-start-4">
        <button mat-button type="button" (click)="onCancelar()" [class.invisible]="filtros().primeiraSelecao">
          Cancelar
        </button>
        <button
          class="slc-btn-filled-brand"
          mat-flat-button
          type="button"
          (click)="onAplicar($event)"
          [disabled]="filtros().invalid"
        >
          Aplicar
        </button>
      </div>
    </div>
  </form>
}

<ng-template #listaValoresPopover let-filtro="filtro">
  <div class="max-w-80">
    <div class="text-wrap">
      <strong>{{ filtro.label }}</strong
      >:
      <!-- -->
      @if (filtro.listaValores.min || filtro.listaValores.max) {
        <!-- -->
        @if (filtro.listaValores.min) {
          &#8805;
          <!---->
          @if (filtro.componente === 'dateRange') {
            {{ filtro.listaValores.min | date }}
          } @else {
            {{ filtro.listaValores.min | number: '0.2-2' }}
          }
        }
        <!-- -->
        @if (filtro.listaValores.max) {
          &#8804;
          <!---->
          @if (filtro.componente === 'dateRange') {
            {{ filtro.listaValores.max | date }}
          } @else {
            {{ filtro.listaValores.max | number: '0.2-2' }}
          }
        }
        <!-- -->
      } @else if (filtro.componente === 'date') {
        {{ filtro.listaValores | date }}
      } @else {
        {{ filtro.listaValores }}
      }
    </div>
  </div>
</ng-template>

<ng-template #limitePopover>
  <div class="max-w-80 text-red-600">
    <p>
      A consulta atingiu o limite máximo de itens. Com isso nem todas as linhas existentes na base de dados que atendem
      os filtros utilizados foram retornadas. Favor utilizar filtros mais restritivos.
    </p>
  </div>
</ng-template>

<ng-template #errorMessagePopover let-control>
  <div class="max-w-80 text-red-600">
    @if (control.errors?.numeroInvalido) {
      <p>Valor inválido. Este campo aceita apenas números, "," (lista de valores) e "-" (intervalos).</p>
    }
    @if (control.controls?.min?.errors?.matDatepickerParse) {
      <p>Data inicial inválida.</p>
    }
    @if (control.controls?.max?.errors?.matDatepickerParse) {
      <p>Data final inválida.</p>
    }
    @if (control.errors?.matDatepickerParse) {
      <p>Data inválida</p>
    }
    @if (control.errors?.required) {
      <p>Campo obrigatório</p>
    }
  </div>
</ng-template>

<ng-template #infoPopover let-info="info">
  <div class="max-w-80">
    <p>
      {{ info }}
    </p>
  </div>
</ng-template>
